import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import UsersList from "@/pages/accounts/list/UsersList.tsx";
import {UsersActionBar} from "@/pages/accounts/UsersActionBar.tsx";
import {AccessDeniedPage} from "@/pages/website/AccessDeniedPage.tsx";

export const UsersPage = () => {
  const {user} = useCurrentUserContext();

  if (!user?.has_admin_access || user?.account.is_subaccount) {
    return <AccessDeniedPage />;
  }

  return (
    <ContentContainer
      title="User Management"
      actionsBar={user?.has_admin_access && <UsersActionBar title="Invite User" />}
    >
      <Helmet>
        <title>User Management</title>
      </Helmet>
      <UpErrorBoundary>
        <UsersList />
      </UpErrorBoundary>
    </ContentContainer>
  );
};
